module.exports = __webpack_public_path__ + "img/master-card.19acd0b1.svg";